module.exports = __webpack_public_path__ + "static/media/register-title.8f1ee277.svg";